export const GET_PICKUP_LOCATIONS = "GET_PICKUP_LOCATIONS";
export const CREATE_PICKUP_LOCATION = "CREATE_PICKUP_LOCATION";
export const GET_PICKUP_LOCATION_DETAIL = "GET_PICKUP_LOCATION_DETAIL";
export const UPDATE_PICKUP_LOCATION_CARRIER_CONNECTIONS =
  "UPDATE_PICKUP_LOCATION_CARRIER_CONNECTIONS";
